module.exports = __FOREMAN_VENDOR__REACT_DOM__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_DOM__"
// module id = react-dom
// module chunks = 0